<ol class="breadcrumb actions">
  @if (!isEditMode && routePerson && canCreate) {
    <li class="d-inline-block" (click)="addNewPerson()">
      <button mat-icon-button class="btn btn-outline-primary" placement="bottom auto"
        ngbTooltip="Neu" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </li>
  }

  @if (!isEditMode && isTerminalSelected && routePerson && canDelete) {
    <li class="d-inline-block"
      (click)="deleteTerminalQuestion()">
      <button mat-icon-button class="btn btn-outline-danger" placement="bottom auto"
        ngbTooltip="Löschen" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>delete</mat-icon>
      </button>
    </li>
  }

  @if (isTerminalSelected) {
    @if (isEditMode) {
      <li class="d-inline-block" [class.backdrop-visible]="isBackdropOkay">
        @if (!isSaveable()) {
          @if (!isFormularValid) {
            <div class="d-inline-block pop-error">
              <button (click)="showError()"
                mat-icon-button class="btn btn-outline-danger disabled"
                placement="bottom-left">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          }
          @if (isFormularValid) {
            <button mat-icon-button class="btn btn-outline-success disabled" disabled>
              <mat-icon>save</mat-icon>
            </button>
          }
        }
        @if (isSaveable()) {
          <button (click)="savePerson()" mat-icon-button class="btn btn-success"
            ngbTooltip="Speichern" container="body" tooltipClass="myTooltip"
            triggers="hover">
            <mat-icon>save</mat-icon>
          </button>
        }
      </li>
      <!--<li class="vertical-line"></li>-->
    }
    @if (isEditMode) {
      <li class="d-inline-block" [class.backdrop-visible]="isBackdropOkay">
        @if (!isChanged()) {
          <button (click)="discardChanges()" mat-icon-button class="btn btn-outline-primary disabled" disabled="disabled">
            <mat-icon>undo</mat-icon>
          </button>
        }
        @if (isChanged()) {
          <button (click)="discardChanges()" mat-icon-button class="btn btn-outline-primary"
            ngbTooltip="Änderungen verwerfen" container="body" tooltipClass="myTooltip"
            triggers="hover">
            <mat-icon>undo</mat-icon>
          </button>
        }
      </li>
      <!--<li class="vertical-line"></li>-->
    }
    @if (isEditMode && isChanged()) {
      <li class="d-inline-block"
        [class.backdrop-visible]="isBackdropOkay">
        <button (click)="cancel()" mat-icon-button class="btn btn-outline-primary"
          ngbTooltip="Abbrechen" container="body" tooltipClass="myTooltip" triggers="hover">
          <mat-icon>close</mat-icon>
        </button>
      </li>
    }
    @if (isEditMode && !isChanged()) {
      <li class="d-inline-block"
        [class.backdrop-visible]="isBackdropOkay">
        <button (click)="stopEditMode()" mat-icon-button class="btn btn-outline-primary"
          ngbTooltip="Abbrechen" container="body" tooltipClass="myTooltip" triggers="hover">
          <mat-icon>close</mat-icon>
        </button>
      </li>
    }
    @if (!isEditMode && routePerson && isAnyWriteable) {
      <li class="d-inline-block"
        [class.backdrop-visible]="isBackdropOkay">
        <button (click)="startEditMode()" mat-icon-button class="btn btn-outline-primary"
          ngbTooltip="Bearbeiten" container="body" tooltipClass="myTooltip" triggers="hover">
          <mat-icon>edit</mat-icon>
        </button>
      </li>
    }
  }
  <li class="d-inline-block">
    <button (click)="updateData()" mat-icon-button class="btn btn-outline-primary renew"
      ngbTooltip="Liste aktualisieren" container="body" tooltipClass="myTooltip" triggers="hover">
      <mat-icon>autorenew</mat-icon>
    </button>
  </li>
  @if (!isTerminalSelected) {
    <li class="d-inline-block">
      <button (click)="uploadUpdate()" mat-icon-button class="btn btn-outline-primary renew"
        ngbTooltip="Update einspielen" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>system_update</mat-icon>
      </button>
    </li>
  }
  @if (!isTerminalSelected) {
    <li class="d-inline-block">
      <button (click)="openUpdateProtocol()" mat-icon-button class="btn btn-outline-primary renew"
        ngbTooltip="Upload Status öffnen" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>published_with_changes</mat-icon>
      </button>
    </li>
  }
</ol>

<ng-template #popError>
  <!-- Error Messages -->
  <div [innerHTML]="managementService.formularErrors"></div>
</ng-template>
